import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    //  Tags
    getAllTags: (
      idList,
      onlyEnabled,
      onlyUsed,
      pageSize,
      pageNumber,
      orderBy,
      orderDescending
    ) =>
      `${baseURL}/api/tags?${encodeParams({
        idList,
        onlyEnabled,
        onlyUsed,
        pageSize,
        pageNumber,
        orderBy,
        orderDescending
      })}`,

    getTag: idTag => `${baseURL}/api/tags/${idTag}`,

    addNewTag: () => `${baseURL}/api/tags`,

    //  Lists
    getList: idList => `${baseURL}/api/list/${encodeURIComponent(idList)}`,

    setWelcomeMessage: idList =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/welcome/toggle`,

    getEntitiesUsingFilter: idFilter =>
      `${baseURL}/api/filter/${encodeURIComponent(idFilter)}/entities`,

    getListOfNlList: (force, pageSize, pageNumber, orderBy, orderDescending) =>
      `${baseURL}/api/lists?${encodeParams({
        force,
        pageSize,
        pageNumber,
        orderBy,
        orderDescending
      })}`,

    getUserVisibleLists: (idUser, pageNumber, pageSize) =>
      `${baseURL}/api/user/${encodeURIComponent(idUser)}/lists?${encodeParams({
        pageNumber,
        pageSize
      })}`,
    getTrackingInfoCustomParams: idList =>
    `${baseURL}/api/list/${encodeURIComponent(idList)}`,

    initMandatorySenderWithAnagraphicData: idList =>
    `${baseURL}/api/list/${encodeURIComponent(idList)}/mandatorysender/init`,

    getMandatorySender: idList =>
    `${baseURL}/api/list/${encodeURIComponent(idList)}/mandatorysender`,

    putSenderInfo: idList =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/sender/info`,
    getUserColumns: (idList) => `${baseURL}/api/users/list/${idList}/columns`,
    updateUserColumns: (idList) => `${baseURL}/api/users/list/${idList}/columns`
  }
})(process.env.BELIST_URL)

export const BeListApiGetList = idList => {
  const url = endpoints.getList(idList)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const BeListApiSetWelcomeMessage = (idList, status) => {
  const url = endpoints.setWelcomeMessage(idList)

  return apiWrapper({
    method: 'put',
    url: url,
    data: JSON.stringify({ WelcomeMsgEnabled: status })
  }).then(extractApiData)
}

/**
 * @description Get a list of detailed lists
 * @param {Object} params
 * @param {boolean} params.force filtering flag, if present show only list linked to a specific UserId
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {string} params.orderBy Order by specified field
 * @param {string} params.orderDescending Order descending
 *
 *
 */
export const BeListApiGetListOfNlList = (
  { force, pageSize, pageNumber, orderBy, orderDescending } = {
    force: true,
    pageSize: 0,
    pageNumber: 1
  }
) => {
  const url = endpoints.getListOfNlList(
    force,
    pageSize,
    pageNumber,
    orderBy,
    orderDescending
  )

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const BeListApiGetAllTags = (
  idList,
  onlyEnabled = false,
  onlyUsed = false,
  pageSize = 0,
  pageNumber = 1,
  orderBy = 'Id',
  orderDescending = true
) => {
  const url = endpoints.getAllTags(
    idList,
    onlyEnabled,
    onlyUsed,
    pageSize,
    pageNumber,
    orderBy,
    orderDescending
  )

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const BeListApiAddNewTag = (pIdList, pTagName) => {
  const url = endpoints.addNewTag()
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify({ idlist: pIdList, name: pTagName, enabled: true })
  }).then(extractApiData)
}

export const beListGetUserVisibleLists = (
  idUser,
  pageNumber = 1,
  pageSize = 0
) => {
  const url = endpoints.getUserVisibleLists(idUser, pageNumber, pageSize)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beListGetTrackingInfoCustomParams = idList => {
  const url = endpoints.getTrackingInfoCustomParams(idList)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beListInitMandatorySenderWithAnagraphicData = idList => {
  const url = endpoints.initMandatorySenderWithAnagraphicData(idList)
  return apiWrapper({
    method: 'post',
    url: url
  }).then(extractApiData)
}

export const beListGetMandatorySender = idList => {
  const url = endpoints.getMandatorySender(idList)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beListPutSenderInfo = (idList, data) => {
  const url = endpoints.putSenderInfo(idList)

  return apiWrapper({
    method: 'put',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beListGetUserColumns = (idList) => {
  const url = endpoints.getUserColumns(idList)

  return apiWrapper({
    method: 'get',
    url: url
  }).then((res) => res.data)
}

export const beListUpdateUserColumns = (idList, data) => {
  const url = endpoints.updateUserColumns(idList)

  return apiWrapper({
    method: 'put',
    url: url,
    data: data
  }).then((res) => res.data)
}
